import { designListParams } from '~/lib/notification/designTemplates';
import { type ApiEnvelope, unwrapResult } from '~/modules/query/base';
import { notificationApi } from '~/modules/query/notification';
import type {
  DesignTemplate,
  DesignTemplatePage,
  ListDesignTemplatesArgs,
} from '~/modules/query/notification/types';

const seg = encodeURIComponent;

/** service-design's email designs, read through service-notification, so templates talk to one service. */
export const designTemplatesApi = notificationApi.injectEndpoints({
  endpoints: (builder) => ({
    listDesignTemplates: builder.query<DesignTemplatePage, ListDesignTemplatesArgs>({
      query: ({ name, pageIndex }) => ({
        url: '/design-templates',
        method: 'GET',
        params: designListParams(name, pageIndex),
      }),
      transformResponse: (
        body: ApiEnvelope<DesignTemplate[]> & { meta?: { hasMore?: boolean } },
      ) => ({
        items: body.result ?? [],
        hasMore: body.meta?.hasMore ?? false,
      }),
    }),
    getDesignTemplate: builder.query<DesignTemplate, string>({
      query: (id) => ({ url: `/design-templates/${seg(id)}`, method: 'GET' }),
      transformResponse: unwrapResult<DesignTemplate>,
    }),
  }),
});

export const { useListDesignTemplatesQuery, useGetDesignTemplateQuery } = designTemplatesApi;
